<template>
  <v-btn
    v-bind="$attrs"
    @click="connectApp()"
  >
    <v-icon
      v-if="integration.icon"
      left
    >
      {{ integration.icon }}
    </v-icon>
    Connect to {{ integration.name }}
  </v-btn>
</template>

<script>
import { auth } from '@/plugins/firebase'
import { getRedirectURL } from '@/components/integrations'

export default {
  props: {
    integration: {
      type: Object,
      required: true
    }
  },
  methods: {
    async connectApp () {
      let url = this.integration.authUrl
      url += `?client_id=${this.integration.clientId}`
      url += `&redirect_uri=${encodeURIComponent(getRedirectURL(this.integration.id))}`
      url += '&response_type=code'

      if (this.integration.additionalData) {
        for (const key in this.integration.additionalData) {
          url += `&${key}=${encodeURIComponent(this.integration.additionalData[key])}`
        }
      }

      const token = await auth.currentUser.getIdToken(true)
      url += `&state=${token}`
      window.open(url, `Authorize ${this.integration.id}`, 'resizable,status,scrollbars,height=600,width=500')
    }
  }
}
</script>
